"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connection = void 0;
const tslib_1 = require("tslib");
const sdk_utils_1 = require("@ihr-radioedit/sdk-utils");
const axios_1 = tslib_1.__importDefault(require("axios"));
const qs = tslib_1.__importStar(require("qs"));
const errors_1 = require("./errors");
class Connection {
    constructor(config = {}, interceptors = []) {
        this.config = config;
        this.interceptors = interceptors;
        this.client = this.create(config, interceptors);
    }
    get http() {
        return this.client;
    }
    create(config, interceptors) {
        config = this.modifyConfig(config);
        interceptors = this.modifyIntercepts(interceptors);
        const client = axios_1.default.create(config);
        if (interceptors) {
            interceptors.forEach(({ onFulfilled, onRejected }) => {
                client.interceptors.request.use(onFulfilled, onRejected);
            });
        }
        // NOTE: This interceptor wraps the standard axios response/error into an easier to use HTTPError
        client.interceptors.response.use(response => response, error => Promise.reject(errors_1.HTTPError.fromAxiosResponse(error)));
        return client;
    }
    // Designed to be overridden in base classes
    modifyConfig(config) {
        return Object.assign({ headers: {}, proxy: this.detectProxy(), paramsSerializer: params => qs.stringify(params, { encode: false }) }, config);
    }
    // Designed to be overridden in base classes
    modifyIntercepts(interceptors) {
        return interceptors;
    }
    detectProxy() {
        const proxyURL = sdk_utils_1.environ.get("HTTP_PROXY", "");
        if (proxyURL) {
            const { hostname, port } = new URL(proxyURL);
            return {
                host: hostname,
                port: parseInt(port, 10),
            };
        }
        return false;
    }
}
exports.Connection = Connection;
//# sourceMappingURL=connection.js.map